<template>
  <el-dialog :visible.sync="dialogVisible" :width="dialogWidth" :before-close="handleClose"
    :modal-append-to-body='false'>
    <div style="margin:0 auto; position: relative;" class="cardListImg">
      <el-image :src="carouselDate.imgUrl"></el-image>
      <h3 class="title">{{ carouselDate.title }}</h3>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      carouselDate: [],
      dialogWidth: '60%',

    }
  },
  methods: {
    async open(data) {
      this.carouselDate = data;
      this.dialogVisible = true;
      this.convertDialogSize(data.imgUrl)

    },
    handleClose() {
      this.carouselDate = [];
      this.dialogVisible = false;
    },
    convertDialogSize(url) {
      let imgObj = new Image()
      imgObj.src = url
      imgObj.onload = () => {
        let width = imgObj.width
        let height = imgObj.height
        let screenWidth = document.documentElement.clientWidth;
        if (width < screenWidth) {
          this.dialogWidth = (width + 40) + 'px'
        }
      }
    }

  },
  mounted() {
    let screenWidth = document.documentElement.clientWidth;
    if (screenWidth <= 768) {
      this.dialogWidth = '80%';
    } else {
      this.dialogWidth = '40%';
    }
  },
}
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  background: none;
  box-shadow: none;
}

.el-image {
  // width: 100%;
  // max-width:450px;

}

.title {
  background: rgba(0, 0, 0, .5);
  margin: -4px 0 0;
  line-height: 40px;
  font-size: 16px;
  font-weight: normal;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  overflow: hidden;
  /*隐藏*/
  white-space: nowrap;
  /*不换行*/
  text-overflow: ellipsis;
  /* 超出部分省略号 */
  width: 100%;
  z-index: 9999;
  bottom: 0;
  left: 0px;
  display: inline-block;
  color: #fff;
  position: absolute;

}

.cardListImg {
  width: 100%;
}

/deep/.el-dialog__wrapper {
  position: absolute !important;
}

/deep/.v-modal {
  position: absolute !important;
}

/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-size: 30px;
}

@media (min-width: 768px) and (max-width: 1024px) {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/components/imgDialog.vue